export const isTiktokMusicUrl = (url: string) => {
    const regex = /^https:\/\/www\.tiktok\.com\/music\/[A-Za-z0-9\-_']+\/?(\?.*)?$/;
    return regex.test(url);
};

const sanitizeTiktokUrl = (url: string) => {
    let sanitizedUrl = url;

    if (url.includes('?')) {
        sanitizedUrl = url.split('?')[0];
    }

    return sanitizedUrl;
};

export const getIdPathFromUrl = (url: string) => {
    const sanitizedUrl = sanitizeTiktokUrl(url);
    return sanitizedUrl.split('/').pop() ?? '';
};

export const getTiktokIDFromIdPath = (idPath: string) => {
    // TikTok music URLs are "title-slug-{id}": take only the trailing digits, since a title
    // containing a number (e.g. "Back on 74") would otherwise get glued onto the real id.
    return idPath.match(/(\d+)$/)?.[1] ?? '';
};
